import axiosInstance from '../../../core/api/axios';
import { Revision, RevisionResponse } from '../models/Revision.model';

interface IRevisionAnswer {
  answer: string[];
  correct: boolean;
  question: string;
}

export async function getRevisions(
  courseId: string
): Promise<RevisionResponse> {
  try {
    const response = await axiosInstance.get(`/r7/${courseId}`);

    return response.data;
  } catch (e: any) {
    throw new Error(e);
  }
}

export async function getRevision(revisionId: string): Promise<Revision> {
  try {
    const response = await axiosInstance.get(`/r7/revision/${revisionId}`);

    return response.data;
  } catch (e: any) {
    throw new Error(e);
  }
}

export async function checkRevisionAnswer(
  revisionId: string,
  data: IRevisionAnswer
) {
  try {
    const response = await axiosInstance.post(`/r7/${revisionId}/check`, data);

    return response.data;
  } catch (e: any) {
    throw new Error(e);
  }
}

export async function finishRevision(
  revisionId: string,
  forceNewDate?: boolean
) {
  try {
    const response = await axiosInstance.post(
      `/r7/${revisionId}/finish`,
      null,
      { params: forceNewDate ? { forceNewDate: true } : undefined }
    );

    return response.data;
  } catch (e: any) {
    throw new Error(e);
  }
}

export async function hideRevision(topicId: string): Promise<void> {
  try {
    await axiosInstance.put(`/r7/${topicId}/hide`);
  } catch (e: any) {
    throw new Error(e);
  }
}
